import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "store";
import {
  getPlayerRiskProfile,
  handleUpdateFieldsRiskProfile,
} from "store/players/list/slice";

import InnerInput from "components/inputs/InnerInput/InnerInput";
import DefaultDropdown from "components/dropdowns/DefaultDropdown/DefaultDropdown";
import ModalTabSkeleton from "components/global/Skeleton/ModalTabSkeleton/ModalTabSkeleton";
import { usePermissionHelper } from "helpers/usePermissionHelper";
import { formatDateTime, useTimeFormat } from "helpers/timeFormat";

const ListRiskProfileTab: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const timeFormat = useTimeFormat();
  const entityId = searchParams.get("entityId");
  const riskProfile = useAppSelector((store) => store.players.riskProfile);
  const isRiskProfileFetched = useAppSelector(
    (store) => store.players.isRiskProfileFetched,
  );
  const permissions = usePermissionHelper();
  const canUpdate = permissions?.update ?? false;

  useEffect(() => {
    if (entityId) {
      dispatch(getPlayerRiskProfile(entityId));
    }
  }, [dispatch, entityId]);

  const riskOptions = [
    {
      value: "none",
      label: "none",
    },
    {
      value: "low",
      label: "low",
    },
    {
      value: "medium",
      label: "medium",
    },
    {
      value: "high",
      label: "high",
    },
    {
      value: "blocked",
      label: "blocked",
    },
  ];

  if (!isRiskProfileFetched) {
    return <ModalTabSkeleton />;
  }

  return (
    <div className="risk-profile-content">
      <div className="risk-profile-content__left">
        <div className="risk-box">
          <div className="risk-box__item">
            <div className="risk-level-row">
              <div className="risk-level-row__select">
                <DefaultDropdown
                  value={riskProfile?.riskLevel ?? "none"}
                  label={t("riskLevel")}
                  options={riskOptions}
                  disabled={!canUpdate}
                  onSelect={(e) => {
                    dispatch(
                      handleUpdateFieldsRiskProfile({
                        riskLevel: e.toString(),
                      }),
                    );
                  }}
                />
              </div>

              <div
                className={`badge badge--${riskProfile?.riskLevel ?? "none"}`}
              >
                {riskProfile?.riskLevel ?? "none"}
              </div>
            </div>
          </div>

          <div className="risk-box__item">
            <InnerInput
              value={riskProfile?.reason ?? ""}
              placeholder={t("enterText")}
              label={t("reason")}
              type="textarea"
              id="risk-reason"
              rows={6}
              disabled={!canUpdate}
              onChange={(e) => {
                dispatch(
                  handleUpdateFieldsRiskProfile({
                    reason: e,
                  }),
                );
              }}
            />
          </div>

          <div className="risk-box__item risk-box__item--short">
            <InnerInput
              value={riskProfile?.source ?? ""}
              placeholder=""
              label={t("source")}
              type="text"
              id="risk-source"
              onChange={() => {}}
              disabled
            />
          </div>
        </div>
      </div>

      <div className="risk-profile-content__right">
        <div className="risk-box">
          {/* <div className="risk-box__item">
            <InnerInput
              value={riskProfile?.updatedBy ?? ""}
              placeholder=""
              label={t("updatedBy")}
              type="text"
              id="risk-updated-by"
              onChange={() => {}}
              disabled
            />
          </div> */}

          <div className="risk-box__item">
            <InnerInput
              value={
                riskProfile?.createdAt
                  ? formatDateTime(riskProfile.createdAt, timeFormat)
                  : ""
              }
              placeholder=""
              label={t("createdAt")}
              type="text"
              id="risk-created-at"
              onChange={() => {}}
              disabled
            />
          </div>

          <div className="risk-box__item">
            <InnerInput
              value={
                riskProfile?.updatedAt
                  ? formatDateTime(riskProfile.updatedAt, timeFormat)
                  : ""
              }
              placeholder=""
              label={t("updatedAt")}
              type="text"
              id="risk-updated-at"
              onChange={() => {}}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListRiskProfileTab;
